export default __webpack_public_path__ + "static/media/cancel.227cc2c2.svg";